<template>
  <div>
    <div class="row" style="margin-bottom: 1rem">
      <div class="col-sm-6 col-md-4 align-self-end" style="text-align: left">
        <h5>{{ $t('mapas_grid.listado_mapas') }} <span class="badge badge-primary">{{ this.maps.length }}</span></h5>
      </div>

      <div class="col-sm-6 offset-md-4 col-md-4 align-self-end" style="text-align: right">
        <input type="text" class="form-control2" style="width: 100%" v-model="searchText" :placeholder="$t('mapas_grid.buscar_mapa')" minlength="3">
      </div>
    </div>

    <div class="portfolio-filter capas text-center">
      <ul>
        <li v-for="category in categories" :class="{'sel-item':categorySelected === category.id}" @click="categorySelected = category.id">
          {{ category[`title_${locale}`] }}
        </li>
      </ul>
    </div>

    <div class="portfolio-items mapas row" v-if="searchText !== '' && pagedMaps.length === 0">
      <div class="col-12 text-center">
        <p>{{ $t('mapas_grid.sin_resultados') }}</p>
      </div>
    </div>

    <div class="portfolio-items mapas row" v-if="pagedMaps.length > 0">
      <!--<transition-group name="list2" tag="div" class="row">-->
      <MapItem
              v-for="map in pagedMaps"
              :key="map.id"
              :map="map"
      ></MapItem>
      <!--</transition-group>-->
    </div>

    <div class="row" v-if="totalPages > 1">
      <div class="col-12">
        <Paginator :total-pages="totalPages" :current-page.sync="currentPage"></Paginator>
      </div>
    </div>

  </div>
</template>

<script>
    import {LayersService} from "../../../commons/services/layersService";
    import Paginator from "../Paginator";
    import MediaQueryMixin from '../../../commons/mixins/mediaQueryMixin';
    import MapItem from "./MapItem";
    import {ArrayUtils} from "../../../commons/utils/arrayUtils";

    export default {
        name: 'MapsSection',
        components: {MapItem, Paginator},
        mixins: [MediaQueryMixin],
        props: {
            langKey: {
                type: String,
                validator: value => ['es', 'ca'].indexOf(value) !== -1
            }
        },
        data() {
            return {
                maps: [],
                searchText: '',
                categories: [
                    {
                        id: 'ESCENARIOS',
                        title_ca: this.$t('mapas_grid.categoria_escenarios', 'ca'),
                        title_es: this.$t('mapas_grid.categoria_escenarios', 'es'),
                    },
                    {
                        id: 'OTROS',
                        title_ca: this.$t('mapas_grid.categoria_otros', 'ca'),
                        title_es: this.$t('mapas_grid.categoria_otros', 'es'),
                    },
                ],
                categorySelected: 'ESCENARIOS',
                currentPage: 1,
                itemsPerPage: 6,
                totalPages: 0
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
            filteredMaps() {
                let filteredMapsByCategory = this.maps.filter(map => {
                    return map['category'] === this.categorySelected;
                });

                return filteredMapsByCategory.filter(map => {
                    return map[`title_${this.locale}`].toLowerCase().includes(this.searchText.toLowerCase());
                })
            },
            pagedMaps() {
                this.totalPages = Math.ceil(this.filteredMaps.length / this.itemsPerPage);

                if (this.totalPages === 1) return this.filteredMaps;

                const start = (this.currentPage - 1) * this.itemsPerPage;
                let end = this.itemsPerPage * this.currentPage;
                if (end > this.filteredMaps.length) end = this.filteredMaps.length;

                return this.filteredMaps.slice(start, end);
            }
        },
        async mounted() {
            if (this.langKey) {
                this.$i18n.locale = this.langKey;
            }

            await this.loadInitialData();
            this.calcPageSize();
        },
        watch: {
            $mq: function () {
                this.calcPageSize();
            }
        },
        methods: {
            async loadInitialData() {
                try {
                    this.maps = await LayersService.fetchMaps();

                    this.maps = this.sortMaps(this.maps);
                } catch (e) {
                    console.log(e);
                }
            },
            goToPage(pageNumber) {
                this.currentPage = pageNumber;
            },
            next() {
                if (this.currentPage < this.totalPages)
                    this.currentPage++;
            },
            previous() {
                if (this.currentPage > 1)
                    this.currentPage--;
            },
            calcPageSize() {
                let newItemsPerPage = 0;

                if (this.$mq === 'xs') {
                    newItemsPerPage = 1;
                } else {
                    newItemsPerPage = 6;
                }

                if (this.itemsPerPage !== newItemsPerPage) {
                    this.itemsPerPage = newItemsPerPage;
                    this.currentPage = 1;
                }
            },
            sortMaps(maps) {
                const key = `title_${this.locale}`;
                return ArrayUtils.orderByKeys(maps, ['order', key]);
            }
        }
    }
</script>